module.exports = __webpack_public_path__ + "img/starry-night-display.c0a8ebd2.png";